// Auto-open fires at most once per load cycle — otherwise every progressive settle (#964/#967)
// re-opens the current top proposal, yanking the panel out from under an operator reading it.
export function shouldAutoOpenTop(
  userOpened: boolean,
  autoOpened: boolean,
  hasItems: boolean,
): boolean {
  return !userOpened && !autoOpened && hasItems;
}
